import React, { Component } from 'react';
import styles from '../index.css';
import fonts from '../../../../iconfonts.css';
import {observer} from 'mobx-react';
import {Bunker, DryingCleaningUnit} from '../../Game/SubComponents/index';
import {scenario} from '../../../stores/index';
import Drop from "../../DragNDrop/Drop";
import Hopper from "../../Game/SubComponents/Hopper";
import Silo from "../../Game/SubComponents/Silo";

@observer
export default class PathPopupUnit extends Component{
    setItem(id){
        scenario.script[this.props.i].elem = id;
        this.setState({active:false});
    }

    objectName={
        'bunker':{name:"ПРИЙОМКА",domElement:Bunker,icon:fonts.iconInput},
        'hopper':{name:"ХОППЕР",domElement:Hopper,icon:fonts.iconStoring},
        'cleaning':{name:"ОЧИСТКА",domElement:DryingCleaningUnit,icon:fonts.iconCleaning},
        'drying':{name:"СУШКА",domElement:DryingCleaningUnit,icon:fonts.iconDrying},
        'silo':{name:"ЗБЕРІГАННЯ",domElement:Silo,icon:fonts.iconStoring},
        'output':{name:"ВИГРУЗКА",domElement:Bunker,icon:fonts.iconOutput},
        'default':{name:"Оберіть кінцевий елемент",domElement:EmptyData,data:'',icon:fonts.iconInput}
    };

    render(){
        let type = this.props.type;
        const DomElement = this.objectName[type].domElement;
        return(
            <div className={(type === 'cleaning' || type ==='drying' || type === 'hopper' ? styles.pathItem : styles.startFinishItem) + ' ' + styles.pathBodyElement}>
                <h4>{this.objectName[type].name}</h4>
                <div className={styles.actionIcon}><i className={this.objectName[type].icon}/></div>
                <div className={styles.actionContainer} onMouseOver={type!=='default' ? this.props.onMouseOver : null} >
                    <div className={styles.actionCircle + (this.props.active ? " " + styles.currentItem : "")}>
                        {
                            <div className={type === 'cleaning' || type ==='drying' || type === 'hopper' ? styles.actionDCContainer : ''} >
                                {<DomElement drop={this.props.drop} item={this.props} inPath={true} />}
                            </div>
                        }
                        {type !== "bunker" && type !== "default" ?
                            <div className={styles.actionDismiss} onClick={()=>{scenario.deleteElementFromScript(this.props.id)}}>
                                &times;
                            </div>
                            :
                            null
                        }
                    </div>
                </div>
                {<div className={styles.pathItemDefinition}>{(this.props.num + 1) ? "№" + (this.props.num + 1) : ""}<br/>{this.props.name}<br/>{this.props.totalCapacity && this.props.type !=='bunker' ?  this.props.totalCapacity +'т' : ''}</div>}
            </div>
        );
    }
}

const EmptyData = (props)=>(
    <div className={styles.actionCircle}>
        <Drop
            className={styles.dropfield}
            onDrop={()=>{scenario.setLastElem(props.drop)}}
            type={"endElement"}
        />
        <div className={styles.pathEndPlus}>+</div>
    </div>
);


// WEBPACK FOOTER //
// ./src/shared/components/PathPopup/PathPopupUnit/index.js